<template>
  <div id="team" class="team-wrap pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>Our Doctors</span>
            <h2>We provide Exceptional Medical Care For Our Patients</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-3 col-lg-4 col-md-6"
          v-for="team in teams"
          :key="team.id"
          data-aos="fade-up"
          data-aos-duration="1200"
          :data-aos-delay="team.datadelay"
        >
          <div class="team-card style1">
            <div class="team-img"><img :src="team.image" alt="Image" /></div>
            <div class="team-info">
              <h3>{{ team.name }}</h3>
              <span>{{ team.name }}</span>
              <ul class="social-profile list-style style1">
                <li>
                  <a target="_blank" href="https://facebook.com">
                    <i class="ri-facebook-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com">
                    <i class="ri-twitter-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://instagram.com">
                    <i class="ri-instagram-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://linkedin.com">
                    <i class="ri-linkedin-line"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurDoctors",
  data: () => ({
    teams: [
      {
        id: 1,
        datadelay: "200",
        image: require("../../assets/images/team/member-1.jpg"),
        name: "Dr. Ken Moris",
        designation: "Clinical Surgery",
      },
      {
        id: 2,
        datadelay: "300",
        image: require("../../assets/images/team/member-2.jpg"),
        name: "Dr. Michel Jhonson",
        designation: "Orthopedic",
      },
      {
        id: 3,
        datadelay: "400",
        image: require("../../assets/images/team/member-3.jpg"),
        name: "Dr. Luiz Frank",
        designation: "Cardiology",
      },
      {
        id: 4,
        datadelay: "500",
        image: require("../../assets/images/team/member-4.jpg"),
        name: "Dr. Selina Gomez",
        designation: "Neurosurgery",
      },
    ],
  }),
});
</script>